import React, { createContext, useState, useContext, useEffect } from 'react';

const CustomerTypeContext = createContext();

export const CustomerTypeProvider = ({ children }) => {
  // Initialise synchronously from sessionStorage so the value is available on
  // the very first render — prevents the guard in AppContent from incorrectly
  // redirecting to "/" when a user navigates directly to a deep URL.
  const [customerType, setCustomerType] = useState(
    () => sessionStorage.getItem('munchups_customer_type') || null
  );

  // Save customer type to sessionStorage whenever it changes
  useEffect(() => {
    if (customerType) {
      sessionStorage.setItem('munchups_customer_type', customerType);
    }
  }, [customerType]);

  const selectCustomerType = (type) => {
    setCustomerType(type);
  };

  const resetCustomerType = () => {
    setCustomerType(null);
    sessionStorage.removeItem('munchups_customer_type');
  };

  return (
    <CustomerTypeContext.Provider
      value={{
        customerType,
        selectCustomerType,
        resetCustomerType,
        isPrivate: customerType === 'private',
        isCorporate: customerType === 'corporate',
      }}
    >
      {children}
    </CustomerTypeContext.Provider>
  );
};

export const useCustomerType = () => {
  const context = useContext(CustomerTypeContext);
  if (!context) {
    throw new Error('useCustomerType must be used within a CustomerTypeProvider');
  }
  return context;
};